<template>
  <div v-if="!$store.getters.getCharts.length">
    <v-container fluid grid-list-lg text-xs-center px-3 py-2 class="lead-analytics">

      <!-- Dashboard loader -->
      <v-layout row>
        <v-flex xs12>
          <base-loader></base-loader>
        </v-flex>
      </v-layout>
    </v-container>
  </div>

  <div v-else>
    <v-container fluid grid-list-lg text-xs-center px-3 py-2 class="lead-analytics">

      <!-- Dashboard heading -->
      <v-layout row wrap align-center>
        <v-flex xs12 sm4>
          <last-update-time
            :dashboard-id="id">
          </last-update-time>
        </v-flex>
        <v-flex xs12 sm4>
          <pdf-export
            v-if="pdfExport"
            :dashboard-id="id"
            :dashboard-name="name">
          </pdf-export>
        </v-flex>
        <v-flex xs12 sm4>
          <v-btn class="ma-0" @click="showFilters = true" ef-feature-id="filters-btn">
            <v-icon class="mr-1">filter_list</v-icon> {{ translation('filters.btn-filter') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12>
          <v-divider></v-divider>
        </v-flex>
      </v-layout>

      <!-- Dashboard Filters -->
      <v-layout row v-show="showFilters">
        <sales-funnel-requalification-filter
          :dashboard-id="id"
          @close-filters="showFilters = false"
          @apply-filters="fetchDashboardData(); showFilters = false"
          @clear-filters="fetchDashboardData">
        </sales-funnel-requalification-filter>
      </v-layout>

      <!--KPI-->
      <v-layout row wrap justify-center="true">
        <v-flex xs12 sm1 md11 class="widget-kpi-wrapper">
          <widget-kpi
            widget-key="SalesFunnelRequalification_kpiReqOpen"
            class="kkc-kpi pointer"
          />
          <widget-kpi
            widget-key="SalesFunnelRequalification_kpiReqInProcess"
            class="kkc-kpi pointer"
          />
          <widget-kpi
            widget-key="SalesFunnelRequalification_kpiReqClosedNoInterest"
            class="kkc-kpi pointer"
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center="true">
        <v-flex xs12 sm1 md11 class="widget-kpi-wrapper">
          <widget-kpi
            widget-key="SalesFunnelRequalification_kpiOpen"
            class="kkc-kpi pointer"
          />
          <widget-kpi
            widget-key="SalesFunnelRequalification_kpiPending"
            class="kkc-kpi pointer"
          />
          <widget-kpi
            widget-key="SalesFunnelRequalification_kpiClosing"
            class="kkc-kpi pointer"
          />
          <widget-kpi
            widget-key="SalesFunnelRequalification_kpiClosedNoInterest"
            class="kkc-kpi pointer"
          />
          <widget-kpi
            widget-key="SalesFunnelRequalification_kpiClosedWithInterest"
            class="kkc-kpi pointer"
          />
          <widget-kpi
            widget-key="SalesFunnelRequalification_kpiTradeIn"
            class="kkc-kpi pointer"
          />
          <widget-kpi
            widget-key="SalesFunnelRequalification_kpiConverted"
            class="kkc-kpi pointer"
          />
          <widget-kpi
            widget-key="SalesFunnelRequalification_kpiConvertedClosed"
            class="gray-kkc-kpi gray-pointer"
          />
        </v-flex>
      </v-layout>

       <v-layout row wrap>
        <v-flex xs12 v-if="hideCharts.indexOf('SalesFunnelRequalification_LeadConversionDetails') === -1">
          <chart-table
            chart-key="SalesFunnelRequalification_LeadConversionDetails"
            @open-dialog="openDialog($event)">
          </chart-table>
        </v-flex>
      </v-layout>

      <!-- chart dialog window -->
      <v-dialog max-width v-model="dialog" @input="closeDialog()">
        <v-card>
          <v-card-title class="subheading">
            {{ dialogTitle }}
            <v-spacer></v-spacer>
            <v-btn icon small class="ma-0" @click.stop="closeDialog()">
              <v-icon>fullscreen_exit</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div class="chart-wrapper">
              <component
                :is="dialogComponent"
                v-bind="dialogProperties"
                :from-dialog="true">
              </component>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import BaseLoader from '@/components/loaders/BaseLoader'
import { eventBus } from '@/eventBus'
import { mapGetters, mapMutations } from 'vuex'
import * as am4core from '@amcharts/amcharts4/core'
import { am4themesEfdTheme } from '@/themes/index'
import ChartFunnel from '@/components/charts/ChartFunnel'
import WidgetKpi from '@/components/charts/WidgetKpi'
import ChartTable from '@/components/charts/ChartTable'
// import LeadsFilter from '@/components/dashboards/inside/DashboardSalesFunnelRequalificationFilterGen'
import SalesFunnelRequalificationFilter from '@/components/dashboards/inside/DashboardSalesFunnelRequalificationFilterGenSidebar'
import LastUpdateTime from '@/components/LastUpdateTime'

// am4core.useTheme(am4themesAnimated)
am4core.useTheme(am4themesEfdTheme)

export default {
  name: 'DashboardSalesFunnelRequalification',
  components: {
    ChartFunnel,
    SalesFunnelRequalificationFilter,
    LastUpdateTime,
    BaseLoader,
    WidgetKpi,
    ChartTable
  },
  data () {
    return {
      id: 'SalesFunnelRequalification',
      name: 'Sales Funnel Analytics',
      charts: [
        {
          key: 'SalesFunnelRequalification_kpiReqOpen',
          title: 'chart.title.SalesFunnelRequalification_kpiReqOpen',
          loaded: false,
          data: {},
          pagination: {}
        },
        {
          key: 'SalesFunnelRequalification_kpiReqInProcess',
          title: 'chart.title.SalesFunnelRequalification_kpiReqInProcess',
          loaded: false,
          data: {},
          pagination: {}
        },
        {
          key: 'SalesFunnelRequalification_kpiReqClosedNoInterest',
          title: 'chart.title.SalesFunnelRequalification_kpiReqClosedNoInterest',
          loaded: false,
          data: {},
          pagination: {}
        },
        {
          key: 'SalesFunnelRequalification_kpiClosing',
          title: 'chart.title.SalesFunnelRequalification_kpiClosing',
          loaded: false,
          data: {},
          pagination: {}
        },
        {
          key: 'SalesFunnelRequalification_kpiOpen',
          title: 'chart.title.SalesFunnelRequalification_kpiOpen',
          loaded: false,
          data: {},
          pagination: {}
        },
        {
          key: 'SalesFunnelRequalification_kpiPending',
          title: 'chart.title.SalesFunnelRequalification_kpiPending',
          loaded: false,
          data: {},
          pagination: {}
        },
        {
          key: 'SalesFunnelRequalification_kpiClosedWithInterest',
          title: 'chart.title.SalesFunnelRequalification_kpiClosedWithInterest',
          loaded: false,
          data: {},
          pagination: {}
        },
        {
          key: 'SalesFunnelRequalification_kpiClosedNoInterest',
          title: 'chart.title.SalesFunnelRequalification_kpiClosedNoInterest',
          loaded: false,
          data: {},
          pagination: {}
        },
        {
          key: 'SalesFunnelRequalification_kpiTradeIn',
          title: 'chart.title.SalesFunnelRequalification_kpiTradeIn',
          loaded: false,
          data: {},
          pagination: {}
        },
        {
          key: 'SalesFunnelRequalification_kpiConverted',
          title: 'chart.title.SalesFunnelRequalification_kpiConverted',
          loaded: false,
          data: {},
          pagination: {}
        },
        {
          key: 'SalesFunnelRequalification_kpiConvertedClosed',
          title: 'chart.title.SalesFunnelRequalification_kpiConvertedClosed',
          loaded: false,
          data: {},
          pagination: {}
        },
        {
          key: 'SalesFunnelRequalification_LeadConversionDetails',
          title: 'chart.title.SalesFunnelRequalification_LeadConversionDetails',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {},
          data: {},
          pagination: {
            totalItems: 0,
            descending: false,
            sortBy: null,
            page: 1,
            rowsPerPage: 10
          }
        }
      ],
      pdfExport: false,
      hideCharts: [],
      showFilters: false,
      // dialog data
      dialog: false,
      dialogComponent: '',
      dialogTitle: '',
      dialogProperties: {}
    }
  },
  computed: {
    ...mapGetters([
      'selectedFilters', 'getCharts', 'getChartByKey', 'translation'
    ]),
    translatedChartTitles: {
      get () {
        return this.charts.map(chart => {
          chart.title = this.translation(chart.title)
          return chart
        })
      }
    }
  },
  created () {
    // remove charts if listed in config
    if (process.env.VUE_APP_HIDE_CHARTS) {
      try {
        this.hideCharts = JSON.parse(process.env.VUE_APP_HIDE_CHARTS)
        if (this.hideCharts.length) {
          this.charts.forEach((chart, index) => {
            if (this.hideCharts.indexOf(chart.key) > -1) {
              this.charts.splice(index, 1)
            }
          })
        }
      } catch (error) {
        this.$log.error('Parse: ', error)
        return
      }
    }

    this.setCharts(this.translatedChartTitles)
  },
  mounted () {
    this.fetchDashboardData()
  },
  beforeDestroy () {
    // empty charts from store
    this.setCharts([])
  },
  methods: {
    ...mapMutations({
      setCharts: 'SET_CHARTS'
    }),
    fetchDashboardData () {
      // emit event for fetching data from components
      eventBus.$emit('update-dashboard')
    },
    openDialog (dialogData) {
      this.$store.dispatch('fetchChartData', {
        key: dialogData.chartObj.key,
        settings: dialogData.chartObj.settings,
        filters: this.$store.getters.isGenericGen ? this.$store.getters.selectedFiltersGen : this.$store.getters.selectedFilters,
        pagination: { ...dialogData.chartObj.pagination, rowsPerPage: dialogData.chartObj.data.metadata.total }
      }).then(() => {
        this.$log.info('dialogData', dialogData)
        // assign received data from clicked component to Dialog component
        this.dialogComponent = dialogData.chartType
        this.dialogProperties = {}
        this.dialogProperties = { chartKey: dialogData.chartObj.key }
        this.dialogTitle = this.getChartByKey(dialogData.chartObj.key).title
        this.dialog = true
      })
    },
    closeDialog () {
      // clear data for component
      this.dialogComponent = ''
      this.dialogProperties = {}
      this.dialogTitle = ''
      this.dialog = false
    }
  }
}
</script>

<style lang="scss">
  .loader-wrapper {
    position: relative;
    height: 50px;
  }
  .dashboard-container {
    height: 100%;
  }
  .sf-analytics {
  }
  .funnel-chart{
    height: 500px;
  }
  .widget-kpi-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .kkc-kpi {
    float: left;
    width: 11%;
    min-width: 150px;
    margin-right: 25px;
    margin-top: 5px;

    .pa-2 {
      font-size: 20px !important;
      height: 50%;
    }

    .display-3 {
      position: absolute;
      bottom: 30px;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      width: 100%;
      font-size: 20px !important;
    }
    .loader{
      position: absolute;
      top: calc(50% - 45px);
      left: calc(50% - 25px);
    }
  }
    .pointer {
      height: 140px;
      position: relative;
      background: white;
    }

    .pointer:before {
      content: "";
      position: absolute;
      right: -20px;
      bottom: 0;
      width: 0;
      height: 0;
      border-left: 20px solid white;
      border-top: 70px solid transparent;
      border-bottom: 70px solid transparent;
    }

    .gray-kkc-kpi {
    float: left;
    width: 11%;
    min-width: 150px;
    margin-right: 25px;
    margin-top: 5px;
    background-color: #DCDCDC !important;

    .pa-2 {
      font-size: 20px !important;
      height: 50%;
    }

    .display-3 {
      position: absolute;
      bottom: 30px;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      width: 100%;
      font-size: 20px !important;
    }
    .loader{
      position: absolute;
      top: calc(50% - 45px);
      left: calc(50% - 25px);
    }
  }
    .gray-pointer {
      height: 140px;
      position: relative;
      background: #DCDCDC;
    }

    .gray-pointer:before {
      content: "";
      position: absolute;
      right: -20px;
      bottom: 0;
      width: 0;
      height: 0;
      border-left: 20px solid #DCDCDC;
      border-top: 70px solid transparent;
      border-bottom: 70px solid transparent;
    }

  @media only screen and (max-device-width: 700px) {
    .sf-analytics {
    }
    .pa-2 {
      font-size: 10px !important;
    }
    .display-3{
      font-size: 10px !important;
    }
  }
</style>
